import React from 'react';
import PropTypes from 'prop-types';
import BarbieLogo from 'assets/images/made-for-barbie-logo.png';
import BipocLogo from 'assets/images/bipoc-badge.png';
import JBImage from 'components/essentials/JBImage';

const dazeyLogo =
  'https://joybird2.imgix.net/user-uploads-staging/JBxDaniDazey-Logo-Button.png';

const PDPMobileStudioCampaignLogo = ({ campaign }) => {
  if (campaign === 'barbie') {
    return (
      <img
        src={BarbieLogo}
        alt="barbie-logo"
        className="w-16 h-16 absolute top-14 left-4 z-50"
      />
    );
  }
  if (campaign === 'dazey') {
    return (
      <JBImage
        src={dazeyLogo}
        className="absolute top-12 left-2 z-50"
        width={100}
      />
    );
  }
  if (campaign === 'bipoc') {
    return (
      <img
        src={BipocLogo}
        alt="bipoc-owned-logo"
        className="w-16 h-16 absolute top-14 left-4 z-50"
      />
    );
  }

  return null;
};

PDPMobileStudioCampaignLogo.propTypes = {
  campaign: PropTypes.string,
};

export default PDPMobileStudioCampaignLogo;
